// import { getRequest, ResponseDI } from '../../services/urlService'
import { result } from "lodash";
import {
  commonUrl,
  getRequest,
  postRequest,
  ResponseDI,
} from "../../../base/services/urlService";
import { Content, Links, Articles } from "../types";
export interface GetContentResponseResultDI {
  renderModeColumn: boolean;
  metaTitle: string;
  Content: Content;
  links: Links;
  articles: Articles;
  LeftContent: Content;
  Layout: number;
  LayoutDesc: string;
}
export interface GetContentTypeDI {
  pageId: number;
  contentType: string;
  breadCrumbs: any;
}

export const getContent = async (id: number, contentType: string) => {
  const url = `${commonUrl}/api/home/${
    contentType === "dynamicContentPage" ? "content" : "preview"
  }?contentPageId=${id.toString()}`;
  const results = await getRequest<ResponseDI<GetContentResponseResultDI>>(url);
  return results.result;
};

export const checkExistUrl = async (path: any) => {
  const url = `${commonUrl}/api/home/GetDocIdByRoute`;
  const results = await postRequest<{}, ResponseDI<GetContentTypeDI>>(url, {
    Route: `${path}`,
  });
  return results.result;
};
